import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Portal } from '@elfsight/widget-modal';
import { useSettings } from '@wu/widget-core';
import { useA11yState } from '../hooks/use-a11y-state';
import { useDemoToggle } from '../hooks/use-demo-toggle';

const LINE_HEIGHT_PX = 10;

export function ReadingLine() {
  const { editMode } = useSettings();
  const { toggleState } = useDemoToggle();
  const { a11yState: { readingLine } = {} } = useA11yState();
  const [mouseY, setMouseY] = useState(0);

  const showLine = !!readingLine && (!editMode || toggleState === 'after');

  const bottom = useMemo(() => {
    if (mouseY > 0) {
      return `calc(100vh - ${mouseY}px - ${LINE_HEIGHT_PX}px - 1px)`;
    }

    return 0;
  }, [mouseY]);

  useEffect(() => {
    if (!readingLine) {
      return;
    }

    const handleMouseMove = (event: MouseEvent) => setMouseY(event.clientY);

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [readingLine]);

  return (
    showLine && (
      <Portal>
        <Line style={{ bottom }} />
      </Portal>
    )
  );
}

const Line = styled.div`
  position: fixed;
  top: auto;
  left: 0;
  right: 0;
  pointer-events: none;
  height: ${LINE_HEIGHT_PX}px;
  background-color: rgb(25, 123, 255);
  z-index: 9999999; // it should be under floating button and modals
`;
